(function () {
  "use strict";

  const data = getData();

  // 3 products are displayed at any one time
  const visibleProductCount = 3;

  // All 4 products are available in the dropdown
  const productNames = Object.keys(data);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    addCompareBtnPDP();
    addComparePopup();
    handleEvents();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");

    style.textContent = `
      body:has(.compare-popup.show) {
        overflow: hidden;
      }

      .compare-btn {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }

      .compare-btn:active {
        transform: scale(0.98);
      }

      .compare-popup {
        --nav-height: 0px;
        display: none;
        position: fixed;
        inset: 0;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
        margin-top: var(--nav-height);
        background: #fff;
        overflow: auto;
        z-index: 9999999;
      }

      .compare-popup-close-btn {
        position: fixed;
        top: calc(var(--nav-height) + 1rem);
        right: 1rem;
        display: flex;
        cursor: pointer;
        z-index: 3;
      }

      .compare-popup-close-btn svg {
        width: 30px;
        height: 30px;
      }

      .compare-popup-close-btn:active svg {
        transform: scale(0.95);
      }

      .compare-popup p {
        margin: 0;
      }

      .compare-popup p.title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
      }

      .compare-popup p.subtitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }

      .compare-popup table {
        width: 100%;
        margin: 0 auto;
        table-layout: fixed;
      }

      .compare-popup table tr {
        background: #fff;
      }

      .compare-popup table tr.row_select {
        position: sticky;
        top: 0;
        z-index: 2;
      }

      .compare-popup table tr.row_info {
        position: sticky;
        top: var(--select-height);
        z-index: 1;
      }

      .compare-popup table tr.row_price {
        position: sticky;
        top: calc(var(--select-height) + var(--info-height));
        z-index: 1;
      }

      .compare-popup table tr.row_cta {
        position: sticky;
        top: calc(
          var(--select-height) +
          var(--info-height) +
          var(--price-height)
        );
        z-index: 1;
      }

      .compare-popup table tr.row_cutoff {
        background: transparent;
      }

      .compare-popup table tr.row_cta {
        box-shadow: 0px 4px 2px -2px #00000040;
      }

      .compare-popup table td {
        padding: 0px 3px;
        vertical-align: middle;
      }

      .compare-popup table tr.row_select td,
      .compare-popup table tr.row_price td,
      .compare-popup table tr.row_cta td,
      .compare-popup table tr.row_cutoff td {
        padding-block: 0.5rem;
      }

      .compare-popup table tr.row_info td {
        vertical-align: top;
      }

      .compare-popup table .select {
        position: relative;
        width: 100%;
      }

      .compare-popup table .select .trigger {
        display: flex;
        position: relative;
        align-items: center;
        cursor: pointer;
        background-color: #fff;
        border: 1.5px solid #e8e9eb;
        border-radius: 2px;
        padding: 1rem 2rem 1rem 1rem;
        height: 70px;
        font-weight: 600;
      }

      .compare-popup table .select .trigger:after {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/c436165bf05bba37de8351ac6640ef40.svg)
          no-repeat center;
        background-size: cover;
        width: 14px;
        height: 7px;
        content: "";
      }

      .compare-popup table .select .trigger span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .compare-popup table .select .options {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        left: 0;
        max-height: 320px;
        border-radius: 4px;
        background: #676669;
        padding: 10px 0;
        overflow-y: auto;
        z-index: 1;
      }

      .compare-popup table .select.open .options {
        display: block;
      }

      .compare-popup table .select .options .option {
        position: relative;
        cursor: pointer;
        padding: 3px 42px;
        color: #fff;
        line-height: 1.7;
      }

      .compare-popup table .select .options .option.selected:before {
        display: block;
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%);
        background: url(https://cdn-x.omniconvert.com/public/uploads/2023-09/85a786792f447dd5bad3b7b35c183ac9.svg)
          no-repeat center;
        background-size: cover;
        width: 18px;
        height: 17px;
        content: "";
      }

      .compare-popup table .select .options .option:hover {
        background: #4687e9;
      }

      .compare-popup table .row_image img {
        max-height: 250px;
        width: auto;
        display: block;
        margin: 0 auto;
      }

      .compare-popup table .info_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .compare-popup table .info_wrapper p:first-child {
        font-size: 14px;
      }

      .compare-popup table .info_wrapper p:nth-child(n + 2) {
        font-size: 12px;
      }

      .compare-popup table .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }

      .compare-popup table .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }

      .compare-popup table .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }

      .compare-popup table .cta_wrapper a {
        width: 100%;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }

      .compare-popup table .data_wrapper {
        padding-block: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
      }

      .compare-popup table .data_wrapper img {
        max-width: 120px;
        max-height: 100px;
      }

      .compare-popup table .data_wrapper:empty {
        display: none;
      }

      .compare-popup table .data_wrapper p {
        font-size: 12px;
      }

      @media (min-width: 1024px) {
        .compare-btn {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }

        .compare-popup p.title {
          font-size: 32px;
        }

        .compare-popup p.subtitle {
          font-size: 16px;
        }

        .compare-popup table td {
          padding-inline: 8px;
        }

        .compare-popup table .info_wrapper p:first-child {
          font-size: 20px;
        }

        .compare-popup table .info_wrapper p:nth-child(n + 2) {
          font-size: 14px;
        }

        .compare-popup table .price_wrapper .price {
          font-size: 22px;
        }

        .compare-popup table .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }

        .compare-popup table .data_wrapper p b {
          font-size: 16px;
        }

        .compare-popup table .data_wrapper img {
          max-width: 200px;
          max-height: 150px;
        }
      }
    `;

    document.head.append(style);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");

    button.classList.add(
      "btn",
      "spec-button",
      "pdp-compare-btn",
    );

    button.textContent = "Compare";

    button.addEventListener("click", function () {
      $(".compare-popup").toggleClass("show");
    });

    $(".nav2-content .spacer").after(button);
  }

  function addComparePopup() {
    const comparePopup = document.createElement("div");

    comparePopup.classList.add("compare-popup");

    comparePopup.innerHTML = `
      <div class="compare-popup-close-btn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
        >
          <path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/>
        </svg>
      </div>

      <div class="page-width">
        <p class="title">
          Compare Cordless Vacuum
        </p>

        <p class="subtitle">
          Discover your perfect cleaning companion choose the right cordless vacuum
          for a smarter, more effortless home.
        </p>

        <table class="compare-table">
          <tbody></tbody>
        </table>
      </div>
    `;

    document.body.append(comparePopup);

    fillComparePopup(comparePopup);

    return comparePopup;
  }

  function fillComparePopup(comparePopup) {
    const tbody = $(comparePopup).find("table tbody");
    const products = Object.entries(data);

    /*
      3 visible columns.
      The initial 3 products are:
      1. AquaMarine
      2. Ultra Detect 2
      3. Pro 2

      Dust Station remains available from every dropdown.
    */

    const initialProducts = products.slice(
      0,
      visibleProductCount,
    );

    /*
      Rows:
      0  = selector
      1  = image
      2  = product info
      3  = price
      4  = CTA
      5  = cutoff
      6-15 = generic detail slots

      Detail slots are populated independently
      from top to bottom for each product.
      Empty details do not consume a slot.
    */

    const totalRows = 16;

    for (
      let rowIndex = 0;
      rowIndex < totalRows;
      rowIndex++
    ) {
      const row = document.createElement("tr");

      tbody.append(row);

      switch (rowIndex) {
        case 0:
          $(row).addClass("row_select");
          break;

        case 1:
          $(row).addClass("row_image");
          break;

        case 2:
          $(row).addClass("row_info");
          break;

        case 3:
          $(row).addClass("row_price");
          break;

        case 4:
          $(row).addClass("row_cta");
          break;

        case 5:
          $(row).addClass("row_cutoff");
          break;

        default:
          $(row).addClass("row_data");
          break;
      }

      for (
        let colIndex = 0;
        colIndex < visibleProductCount;
        colIndex++
      ) {
        const cell = document.createElement("td");

        row.append(cell);

        const prodName =
          initialProducts[colIndex][0];

        const prodData =
          initialProducts[colIndex][1];

        if (rowIndex === 0) {
          cell.innerHTML = `
            <div
              class="select"
              data-column="${colIndex}"
            >
              <div class="trigger">
                <span>${prodName}</span>
              </div>

              <div class="options">
                ${productNames
                  .map(
                    (name) => `
                      <div
                        class="option ${
                          name === prodName
                            ? "selected"
                            : ""
                        }"
                        data-product="${name}"
                      >
                        ${name}
                      </div>
                    `,
                  )
                  .join("")}
              </div>
            </div>
          `;
        } else if (rowIndex === 1) {
          cell.innerHTML = `
            <div class="image_wrapper">
              <img
                src="${prodData.image_url}"
                alt="${prodName}"
                width=""
                height=""
              />
            </div>
          `;
        } else if (rowIndex === 2) {
          cell.innerHTML = `
            <div class="info_wrapper">
              <p>${prodName}</p>
              <p>${prodData.type}</p>
            </div>
          `;
        } else if (rowIndex === 3) {
          cell.innerHTML = `
            <div class="price_wrapper">
              <img
                width="20"
                height="20"
                src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161"
              />

              <span class="price">
                ${theme.Currency.formatMoney(
                  prodData.price,
                )}
              </span>

              <s class="compare_at_price">
                ${theme.Currency.formatMoney(
                  prodData.compare_at_price,
                )}
              </s>
            </div>
          `;
        } else if (rowIndex === 4) {
          cell.innerHTML = `
            <div class="cta_wrapper">
              <a href="${prodData.url}">
                Shop Now
              </a>
            </div>
          `;
        } else if (rowIndex === 5) {
          cell.innerHTML = "";
        } else {
          /*
            Get ONLY populated details.

            This means:
            first populated detail  -> first row_data
            second populated detail -> second row_data
            third populated detail  -> third row_data
            etc.
          */
          const details = Object.entries(
            prodData.details
          ).filter(
            ([key, value]) =>
              value !== null &&
              value !== undefined &&
              value !== ""
          );

          const detailIndex = rowIndex - 6;
          const detail = details[detailIndex];

          if (!detail) {
            cell.innerHTML = "";
            continue;
          }

          const dKey = detail[0];
          const dVal = detail[1];

          const dataWrapper =
            document.createElement("div");

          dataWrapper.classList.add(
            "data_wrapper",
            `data-${dKey}`,
          );

          dataWrapper.innerHTML =
            getDetailsHtml(dKey, dVal);

          cell.append(dataWrapper);
        }
      }
    }
  }

  function handleEvents() {
    const comparePopup = $(".compare-popup");

    /*
      Close popup
    */
    comparePopup.on(
      "click",
      ".compare-popup-close-btn",
      function () {
        comparePopup.removeClass("show");
      },
    );

    /*
      Open / close individual dropdown
    */
    comparePopup.on(
      "click",
      ".select .trigger",
      function (e) {
        e.stopPropagation();

        const select =
          $(this).closest(".select");

        $(".select.open")
          .not(select)
          .removeClass("open");

        select.toggleClass("open");
      },
    );

    /*
      Select a product.
      Only the selected column gets updated.
    */
    comparePopup.on(
      "click",
      ".select .option",
      function (e) {
        e.stopPropagation();

        const option = $(this);
        const select =
          option.closest(".select");

        const columnIndex = Number(
          select.attr("data-column"),
        );

        const productName =
          option.attr("data-product");

        const productData =
          data[productName];

        if (!productData) return;

        /*
          Update selected state
        */
        select
          .find(".option.selected")
          .removeClass("selected");

        option.addClass("selected");

        /*
          Update dropdown label
        */
        select
          .find(".trigger span")
          .text(productName);

        select.removeClass("open");

        /*
          Update only this column
        */
        updateColumn(
          columnIndex,
          productName,
          productData,
        );
      },
    );

    /*
      Close dropdown when clicking outside
    */
    $(document).on(
      "click.compareVacuum",
      function () {
        comparePopup
          .find(".select.open")
          .removeClass("open");
      },
    );
  }

function updateColumn(
  columnIndex,
  productName,
  productData,
) {
  const column = columnIndex + 1;

  /*
    Product info
  */
  $(
    `.compare-table .row_info td:nth-child(${column}) .info_wrapper`,
  ).html(`
    <p>${productName}</p>
    <p>${productData.type}</p>
  `);

  /*
    Product image
  */
  $(
    `.compare-table .row_image td:nth-child(${column}) img`,
  )
    .attr(
      "src",
      productData.image_url,
    )
    .attr(
      "alt",
      productName,
    );

  /*
    Price
  */
  $(
    `.compare-table .row_price td:nth-child(${column}) .price`,
  ).html(
    theme.Currency.formatMoney(
      productData.price,
    ),
  );

  /*
    Compare-at price
  */
  $(
    `.compare-table .row_price td:nth-child(${column}) .compare_at_price`,
  ).html(
    theme.Currency.formatMoney(
      productData.compare_at_price,
    ),
  );

  /*
    Shop Now link
  */
  $(
    `.compare-table .row_cta td:nth-child(${column}) a`,
  ).attr(
    "href",
    productData.url,
  );

  /*
    Get ONLY populated details.

    These will be inserted into the available
    row_data cells from TOP TO BOTTOM.

    Null / empty details do not consume a row.
  */
  const details = Object.entries(
    productData.details
  ).filter(
    ([key, value]) =>
      value !== null &&
      value !== undefined &&
      value !== ""
  );

  const cells = $(
    `.compare-table .row_data td:nth-child(${column})`,
  );

  /*
    Clear this entire product column first.
  */
  cells.empty();

  /*
    Populate from the FIRST row_data downward.
  */
  cells.each(function (index, cell) {
    const detail = details[index];

    if (!detail) {
      return;
    }

    const dKey = detail[0];
    const dVal = detail[1];

    const dataWrapper =
      document.createElement("div");

    dataWrapper.classList.add(
      "data_wrapper",
      `data-${dKey}`,
    );

    dataWrapper.innerHTML =
      getDetailsHtml(dKey, dVal);

    cell.append(dataWrapper);
  });
}

  function assignCssVariables() {
    const comparePopup =
      $(".compare-popup")[0];

    setInterval(() => {
      if (!comparePopup) return;

      comparePopup.style.setProperty(
        "--select-height",
        `${$(".compare-table .row_select").height()}px`,
      );

      comparePopup.style.setProperty(
        "--info-height",
        `${$(".compare-table .row_info").height()}px`,
      );

      comparePopup.style.setProperty(
        "--price-height",
        `${$(".compare-table .row_price").height()}px`,
      );

      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }

  function getDetailsHtml(dKey, dVal) {
    let html = "";

    switch (dKey) {
      case "evopod":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoPodCompatibility.png?v=1788934644"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>${dVal}</b><br/>
            Charging stand with a built-in 2.5L dust bag storage
          </p>
        `;
        break;

      case "dustBag":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoPodDustBag.png?v=1788934691"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>${dVal}</b><br/>
            650ml bin empties itself into a dust bag that holds up to 90 days of dust
          </p>
        `;
        break;

      case "floorBrush":
        switch (dVal) {
          case 1:
            html = `
              <img
                src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/xl_fluffy_floor_brush.png?v=1776068603"
                alt=""
                width=""
                height=""
              />

              <p>
                <b>XL Fluffy Floor Brush</b><br/>
                Wider coverage for faster cleaning in large spaces
              </p>
            `;
            break;

          case 2:
            html = `
              <img
                src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Fluffy_Floor_Brush_d53d528f-3dde-488d-bdac-ebd7f137e5ae.png?v=1782958391"
                alt=""
                width=""
                height=""
              />

              <p>
                <b>Fluffy Floor Brush</b><br/>
                Precision cleaning for tighter spaces and everyday homes
              </p>
            `;
            break;

          case 3:
            html = `
              <img
                src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AquaMarineRoller_Brush_Desktop.png?v=1779680817"
                alt=""
                width=""
                height=""
              />

              <p>
                <b>AquaMarine Floor Brush</b><br/>
                Powerful wet-and-dry cleaning for hard floors
              </p>
            `;
            break;
        }
        break;

      case "ledDisplay":
        switch (dVal) {
          case 1:
            html = `
              <img
                src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/multicolour_led_display.png?v=1776217477"
                alt=""
                width=""
                height=""
              />

              <p>
                <b>4” Multicolour LED Display</b>
              </p>
            `;
            break;

          case 2:
            html = `
              <img
                src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LED_Display.png?v=1782958391"
                alt=""
                width=""
                height=""
              />

              <p>
                <b>LED Digital Display</b>
              </p>
            `;
            break;
        }
        break;

      case "battery":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Battery_4ee368b9-b6ad-4d7a-80eb-a0069dc99ac3.svg?v=1776217335"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>Battery</b><br/>
            ${dVal}
          </p>
        `;
        break;

      case "suction":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Suction.svg?v=1776217335"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>Suction Power</b><br/>
            ${dVal}
          </p>
        `;
        break;

      case "dustLight":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LED_Dust_Light.svg?v=1776217335"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>Green LED Dust Light</b><br/>
            ${dVal}
          </p>
        `;
        break;

      case "engine":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Engine.svg?v=1776217335"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>Engine</b><br/>
            ${dVal}
          </p>
        `;
        break;

      case "hepa":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/HEPA_Filter.svg?v=1776217335"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>HEPA Filter</b><br/>
            ${dVal}
          </p>
        `;
        break;

      case "accessories":
        html = `
          <img
            src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Accessories.svg?v=1776217334"
            alt=""
            width=""
            height=""
          />

          <p>
            <b>Accessories</b><br/>
            ${dVal}
          </p>
        `;
        break;
    }

    return html;
  }

  function getData() {
    return {
      "EvoSonic Ultra Detect 2 AquaMarine": {
        type: "Cordless Vacuum",

        url: "/collections/vacuum/products/evosonic-ultra-detect-aquamarine",

        image_url:
          "https://prismplus.sg/cdn/shop/files/680px-EvoSonicAqM-Thumb1.jpg?v=1779260439",

        price: 18900,
        compare_at_price: 43900,

        details: {
          evopod: "Compatible with EvoPod",
          dustBag: null,
          floorBrush: 3,
          ledDisplay: 1,
          battery: "Up to 90 mins runtime",
          suction: "38000 Pa",
          dustLight: "Yes",
          engine: "HyperDrive Pro 500W BLDC Motor",
          hepa: "99.7% Dual-HEPA Filtration",
          accessories:
            "Different range of tools & Accessories Set",
        },
      },

      "EvoSonic Ultra Detect 2": {
        type: "Cordless Vacuum",

        url: "/products/prism-evosonic-ultra-detect-2",

        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/680px-EvoUltra2-Thumb1_530x%402x.jpg?v=1785995849",

        price: 14900,
        compare_at_price: 29900,

        details: {
          evopod: "Compatible with EvoPod",
          dustBag: null,
          floorBrush: 1,
          ledDisplay: 1,
          battery: "Up to 90 mins runtime",
          suction: "38000 Pa",
          dustLight: "Yes",
          engine: "HyperDrive Pro 500W BLDC Motor",
          hepa: "99.7% Dual-HEPA Filtration",
          accessories:
            "Different range of tools & Accessories Set",
        },
      },

      "EvoSonic Pro 2": {
        type: "Cordless Vacuum",

        url: "/products/prism-evosonic-pro-2-0",

        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/680px-EvoSonicPro-V2-Thumb1.jpg?v=1782286757",

        price: 8900,
        compare_at_price: 22900,

        details: {
          evopod: null,
          dustBag: null,
          floorBrush: 2,
          ledDisplay: 2,
          battery: "Up to 45 mins runtime",
          suction: "25000 Pa",
          dustLight: "Yes",
          engine: "HyperDrive Pro 250W BLDC Motor",
          hepa: "99.7% Dual-HEPA Filtration",
          accessories:
            "Different range of tools & Accessories Set",
        },
      },

      "EvoSonic Ultra 2 Dust Station": {
        type: "Cordless Vacuum",

        url: "/collections/vacuum/products/evosonic-ultra-detect-2-evopod",

        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/EvoPod-Thumb2_1_530x%402x.jpg?v=1788859158",

        price: 20900,
        compare_at_price: 49800,

        details: {
          evopod: "Charge & Store with EvoPod",
          dustBag: "Replaceable Dust Bag",
          floorBrush: 1,
          ledDisplay: 1,
          battery: "Up to 90 mins runtime",
          suction: "38000 Pa",
          dustLight: "Yes",
          engine: "HyperDrive Pro 500W BLDC Motor",
          hepa: "99.7% Dual-HEPA Filtration",
          accessories:
            "Different range of tools & Accessories Set",
        },
      },
    };
  }
})();